import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ScreeningPartiesRoutingModule } from './screening-parties-routing.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SharedModule } from 'src/app/shared/shared.module';
import { ScreeningPartiesHomepageComponent } from './screening-parties-homepage/screening-parties-homepage.component';
import { HostComponent } from './host/host.component';
import { HostGuideComponent } from './host-guide/host-guide.component';
import { HostPartyModule } from './host-party/host-party.module';
import { JoinPartiesComponent } from './host/join-parties/join-parties.component';
import { SortPipe } from 'src/app/core/Pipe/sort.pipe';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
@NgModule({
  declarations: [
    ScreeningPartiesHomepageComponent,
    HostComponent,
    HostGuideComponent,
    HostGuideComponent,
    JoinPartiesComponent,
    SortPipe,
  ],
  imports: [
    CommonModule,
    ScreeningPartiesRoutingModule,
    FlexLayoutModule,
    SharedModule,
    HostPartyModule,
    ScreeningPartiesRoutingModule,
    FormsModule,
    RouterModule,
    MatIconModule,
    MatDialogModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ScreeningPartiesModule { }
